<template>
 <div>
    <div class="p-b-100 columns">
      <div class="column m-t-100 is-12-mobile is-9-widescreen is-9-fullhd p-l-50-fullhd p-r-50-fullhd w-100">
          <back-button class="m-b-10"/>
          <div class="pt-3" v-show="showSearch">
            <div class="dropdown" :class="{ 'is-active': dropdownActive }">
                <div class="dropdown-trigger">
                    <input
                    type="text"
                    class="input input-search"
                    placeholder="Search"
                    v-model="searchQuery"
                    @focus="toggleDropdown(true)"
                    @blur="toggleDropdown(false)"
                    @input="onInput"
                    />
                </div>
                <!-- Dropdown Menu -->
                <div class="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                    <!-- Filtered Items -->
                    <a
                        v-for="(item, index) in filteredItems"
                        :key="index"
                        href="#"
                        class="dropdown-item"
                        @mousedown.prevent="selectItem(item)"
                    >
                        {{ item }}
                    </a>
                    <!-- No Items Found -->
                    <div v-if="filteredItems.length === 0" class="dropdown-item">
                        No items found.
                    </div>
                    </div>
                </div>
            </div>
          </div>
          <div id="static-body" v-if="staticData && staticData.body" class="p-t-20 static-body" v-html="staticData.body"></div>
          <h1 v-else class="is-size-1" v-html="messageError"></h1>
          <Disclaimer class="disclaimer"/>
      </div>
      <div ref="subRight_before" class="column is-12-mobile is-3-widescreen banner-home">
        <div class="banner-on-top" ref="subRight">
            <AdsGoogle v-if="!showAdsPartner" />
            <AdsPartner v-if="showAdsPartner" />
        </div>
      </div>
    </div>
 </div>
</template>
<style scoped>
.static-body::v-deep *:not(iframe) {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    all: revert;
    line-height: normal;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.static-body::v-deep .video-container {
    position: relative;
    width: 100%;
    padding-bottom: 56.7%;
    height: 0;
    overflow: hidden;
}
.static-body::v-deep iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.disclaimer {
    padding-top: 0.75rem;
}
.static-body::v-deep p {
    margin-bottom: 1rem;
    line-height: 1.5;
    color: #24292e;
    font-size: 16px;
    word-wrap: break-word;
}
.static-body::v-deep img {
    max-width: 100%;
}
.static-body::v-deep .link-to-content {
    color: #009BDE;
    text-decoration: inherit;
}
.static-body::v-deep .link-content {
    color: inherit;
    text-decoration: inherit;
}
.static-body::v-deep table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    min-width: 500px;
}
.static-body::v-deep table th, 
.static-body::v-deep table td {
    border: 2px solid #3c4b5f;
    box-sizing: border-box;
    min-width: 1em;
    padding: 3px 5px;
    border-collapse: collapse;
}
.static-body::v-deep table th p,
.static-body::v-deep table td p {
    text-align: left;
    margin: 0;
    word-wrap: normal;
}
.static-body::v-deep .table-section {
    overflow-x: auto;
    background-color: #b9ede8;
}
.dropdown-menu {
    max-height: 300px;
    overflow-y: auto;
}
.input-search {
    background-image: url(/img/search-icon.png);
    background-position: 8px center;
    background-repeat: no-repeat;
    padding-left: 1.75em;
    background-size: 21px;
}
.dropdown-menu .dropdown-content .dropdown-item {
    color: #009BDE;
}
.dropdown-menu .dropdown-content .dropdown-item:hover {
    background-color: #eee;
}
.dropdown-menu .dropdown-content {
    box-shadow: 0 0.5em 1em 0.25em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02)
}
.dropdown-menu {
    overflow: visible;
}
@media (min-width: 769px) {
    .banner-home {
        padding-top: 73.5px;
    }
}
</style>
<script>
import axios from "axios";
import BackButton from '@/components/BackButton.vue';
import Disclaimer from "@/components/Disclaimer";
import bannerMixin from "@/mixins/bannerMixin";
import AdsGoogle from '@/components/AdsGoogle.vue';
import AdsPartner from '@/components/AdsPartner.vue';
export default {
    name: 'Staticpage',
    components: { BackButton, Disclaimer, AdsGoogle, AdsPartner },
    mixins: [bannerMixin],
    data: function () {
        return {
            staticData:null,
            messageError: null,
            showSearch: false,
            dropdownActive: false,
            searchQuery: "",
            items: [],
            filteredItems: [],
            showAdsPartner: false
        }
    },
    mounted(){
        axios.get("/static-page/"+this.$route.params.slug).then(response => {
            this.staticData = response.data;
            const { set } = this.$meta().addApp();
            set({
                title: this.staticData.title_tag + " | Pickafund",
                meta: [
                    { name: 'description', content:  this.staticData.meta_desc},
                ]
            });
        }).catch((error) => {
            if (error) {
                this.messageError = error.response.data.message
            }
        })
    },
    updated () {
        if (this.$route.params.slug == "fund-investing-glossary") {
            this.showSearch = true;
        }
        const partnerSlugs = ["the-end-of-the-cash-isa", "choosing-the-best-investment-platform", "guide-to-fund-investing-uk"]
        if (partnerSlugs.includes(this.$route.params.slug)) {
            this.showAdsPartner = true;
        }
        var div = document.getElementById("static-body");
        var videoPlaceholders = div.querySelectorAll("p");
        for (let i = 0; i < videoPlaceholders.length; i++) {
            if (videoPlaceholders[i].textContent.trim() === "INSERT VIDEO 1 HERE" || 
                videoPlaceholders[i].textContent.trim() === "INSERT VIDEO 1") {
                videoPlaceholders[i].classList.add('video-container');
                videoPlaceholders[i].innerHTML = '<iframe width="100%" src="https://www.youtube.com/embed/-lDyWKyHxBI" frameborder="0" allowfullscreen></iframe>';
            }
            if (videoPlaceholders[i].textContent.trim() === "INSERT VIDEO 2 HERE" || 
                videoPlaceholders[i].textContent.trim() === "INSERT VIDEO 2") {
                videoPlaceholders[i].classList.add('video-container');
                videoPlaceholders[i].innerHTML = '<iframe width="100%" src="https://www.youtube.com/embed/z9DXTMl0IFo" frameborder="0" allowfullscreen></iframe>';
            }
            if (videoPlaceholders[i].textContent.trim() === "INSERT VIDEO 3 HERE" || 
                videoPlaceholders[i].textContent.trim() === "INSERT VIDEO 3") {
                videoPlaceholders[i].classList.add('video-container');
                videoPlaceholders[i].innerHTML = '<iframe width="100%" src="https://www.youtube.com/embed/lXoR8RIfDhU" frameborder="0" allowfullscreen></iframe>';
            }
        }
        var linkToContents = div.querySelectorAll(".link-to-content");
        var linkContents = div.querySelectorAll(".link-content");
        var tables = div.querySelectorAll("table");
        for (let i = 0; i < linkContents.length; i++) {
            let hrefContent = linkContents[i].getAttribute('href');
            linkContents[i].setAttribute('data-id', hrefContent);
        }
        for (let i = 0; i < linkToContents.length; i++) {
            linkToContents[i].addEventListener('click', function(e){
                e.preventDefault();
                let headerHeight = document.querySelector('.navbar-brand').clientHeight + 20;
                let pageOffsetTop = document.querySelector('.Pages').offsetTop;
                let hrefContent = linkToContents[i].getAttribute('href');
                let offsetTop = div.querySelector('[data-id="' + hrefContent + '"]').offsetTop + pageOffsetTop - headerHeight;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth",
                });
            })
        }
        for (let i = 0; i < tables.length; i++) {
            let referenceNode = tables[0];
            let el = document.createElement("div");
            el.className = "table-section";
            referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
            let fragment = document.createDocumentFragment();
            fragment.appendChild(referenceNode);
            el.appendChild(fragment);
        }
        let anchor = '';
        if (this.$route.query.anchor) {
            anchor = this.$route.query.anchor.toLowerCase();
        }
        let nodes = div.querySelectorAll("strong");
        let arrayFilter = [];
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].innerText.trim() !== "" && !nodes[i].querySelector('u')) {
                arrayFilter.push(nodes[i].innerText)
            }
            if (this.$route.query.anchor && nodes[i].innerText.toLowerCase().replace(/\s/g,'').replace('/', '') === anchor) {
                setTimeout(function(){
                    let headerHeight = document.querySelector('.navbar-brand').clientHeight + 20;
                    let pageOffsetTop = document.querySelector('.Pages').offsetTop;
                    let offsetTop = nodes[i].offsetTop + pageOffsetTop - headerHeight;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: "smooth",
                    });
                }, 100)
            }
        }
        arrayFilter = arrayFilter.sort((a, b) => a.localeCompare(b));
        this.items = arrayFilter;

        let anchorSub = this.$route.query.anchorsub;
        if (anchorSub) {
            anchorSub = anchorSub.toLowerCase();
            let nodes = div.querySelectorAll("ul li p");
            for (let i = 0; i < nodes.length; i++) {
                if (nodes[i].innerText.toLowerCase().replace(/\s/g,'').replace('/', '') === anchorSub) {
                    setTimeout(function(){
                        let headerHeight = document.querySelector('.navbar-brand').clientHeight + 20;
                        let pageOffsetTop = document.querySelector('.Pages').offsetTop;
                        let offsetTop = nodes[i].offsetTop + pageOffsetTop - headerHeight;
                        window.scrollTo({
                            top: offsetTop,
                            behavior: "smooth",
                        });
                    }, 100)
                    break;
                }
            }
        }
    },
    methods: {
        toggleDropdown(state) {
            this.dropdownActive = state;
        },
        selectItem(item) {
            this.searchQuery = item;
            this.dropdownActive = false;

            const xpath = `//strong[text()='${item}']`;
            const result = document.evaluate(
                xpath,
                document,
                null,
                XPathResult.FIRST_ORDERED_NODE_TYPE,
                null
            );

            const targetElement = result.singleNodeValue;

            if (targetElement) {
                let headerHeight = document.querySelector('.navbar-brand').clientHeight + 20;
                let pageOffsetTop = document.querySelector('.Pages').offsetTop;
                let offsetTop =targetElement.offsetTop + pageOffsetTop - headerHeight;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth",
                });
            } 
        },
        onInput() {
            const query = this.searchQuery.toLowerCase();
            if (query.trim() === '' ) {
                this.filteredItems = [];
            } else {
                this.filteredItems = this.items.filter((item) =>
                    item.toLowerCase().includes(query)
                );
            }
            
            if (!this.dropdownActive) this.toggleDropdown(true);
        },
    },
}
</script>
